import { jsx } from "react/jsx-runtime";
import Script from "next/script";
function TranscendAirgap({
  transcendConfig,
  isTranscendEnabled
  // isTranscendOverridesEnabled,
}) {
  if (!(transcendConfig == null ? void 0 : transcendConfig.src)) {
    return null;
  }
  const enableConsentMgmt = isTranscendEnabled ? {
    "data-regime": transcendConfig["data-regime"],
    "data-local-sync": "allow-network-observable",
    "data-ui": "off"
  } : {};
  const strategy = "afterInteractive";
  return /* @__PURE__ */ jsx(
    Script,
    {
      id: "CookieMonitoringScript",
      onLoad: (event) => {
        window.airgapLoadEvent = event;
        window.dispatchEvent(
          new CustomEvent("airgapLoadEventReady", {
            detail: event
          })
        );
      },
      src: transcendConfig.src,
      strategy,
      ...enableConsentMgmt
    }
  );
}
export {
  TranscendAirgap
};
